import React from "react";
import FormPageLayout, {
  FormPageLayoutProps,
} from "components/basic/formPageLayout";

type SignUpFormLayoutProps = Pick<
  FormPageLayoutProps,
  "children" | "imageSrc" | "backAction" | "primaryAction"
>;

// The photo-split signup steps: right-aligned fields against a photo on the
// right, centred until they outgrow the window and then scrolling.
const SignUpFormLayout: React.FC<SignUpFormLayoutProps> = (props) => (
  <FormPageLayout
    {...props}
    imagePosition="right"
    contentTextAlign="right"
    contentAlign="end"
    contentMaxWidth={320}
    reserveProgressBar={false}
    centerVertically
  />
);

export default SignUpFormLayout;
